/* This file is autogenerated, see readme.md for instructions */
import GridSvgIcon from '@bloomreach/banana-theme/icons/grid.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const GridIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <GridSvgIcon />
    </Icon>
  );
});

GridIcon.displayName = 'GridIcon';

export default GridIcon;
